import { ChangeEvent } from "react";

export type CustomValueTypeTransform = {
  input: (value: number) => string;
  output: (event: ChangeEvent<HTMLInputElement>) => number | undefined;
};

export const transform: CustomValueTypeTransform = {
  input: (value) => {
    if (!value) {
      return "";
    }
    const hours = Math.floor(value / 60);
    const minutes = value % 60;

    const parsedHours = hours < 10 ? `0${hours}` : `${hours}`;
    const parsedMinutes = minutes < 10 ? `0${minutes}` : `${minutes}`;
    return parsedHours + parsedMinutes;
  },
  output: (event) => {
    const { value } = event.target;

    if (value.length === 5) {
      const [hours, minutes] = value.split(":");
      return Number(hours) * 60 + Number(minutes);
    }
    return undefined;
  }
};
